import React from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import ClaimsList from './claims/List';
import ClaimsCreate from './claims/Create';
import ClaimsDetail from './claims/Detail';

const defaultFields = {
    Subject: { visible: false, label: '', required: false },
    CompensationType: { visible: false, label: '', required: false },
    TaskOrder: { visible: false, label: '', required: false },
    ProjectOrder: { visible: false, label: '', required: false },
    AssessmentAmount: { visible: false, label: '', required: false },
    AlternativeQuotation: { visible: false, label: '', required: false },
    Description: { visible: false, label: '', required: false }
}

const defaultReplyFields = {
    ReplyStatus: { visible: false, label: '', required: false },
    ReplyComment: { visible: false, label: '', required: false },
}

///ALL FIELDS ARE DECIDED WITHIN THE getFields FUNCTION
///THE getFields FUNCTION IS CALLED WITHIN THE adjustContractTemplate and assign fields to workflowItem
export const getFields = (resources, placeholdersQA, workflowsQA, languageFile, wfid, globalResources, contract) => {
    const fields = { ...defaultFields };
    const workflowItem = workflowsQA[wfid];

    fields.Subject = { visible: true, label: languageFile["GENERAL.FORMS.FIELD.SUBJECT"], required: true };

    const typeTemplate = languageFile["GENERAL.FORMS.FIELD.ITEM_TYPE"];

    const type = typeTemplate
        .replace("{ITEM_NAME}", (workflowsQA['46'] || {}).notificationName);


    fields.CompensationType = { visible: true, label: type, required: true };
    let clauses = workflowItem.clauses;
    if (!clauses) {
        clauses = placeholdersQA.ClaimClauses?.values?.filter(item => item.isActive === true);
    }
    fields.CompensationType.clauses = clauses;

    if (placeholdersQA.TaskOrderOptionEnabled) {
        const taskOrderOptionEnabled = placeholdersQA.TaskOrderOptionEnabled?.values
            .find(phItem => phItem.field === 'TaskOrderOptionEnabled').isActive;

        if (taskOrderOptionEnabled) {
            const toTemplate = languageFile["CONTRACT.WF.COMPENSATION.FIELD.TASK_ORDER"];

            const to = toTemplate
                .replace("{TASK_ORDER}", (workflowsQA['38'] || {}).notificationName);

            fields.TaskOrder = { visible: true, label: to, required: false };
        }
    }

    if (placeholdersQA.ProjectOrderOptionEnabled) {
        const projectOrderOptionEnabled = placeholdersQA.ProjectOrderOptionEnabled?.values
            .find(phItem => phItem.field === 'ProjectOrderOptionEnabled').isActive;

        if (projectOrderOptionEnabled) {
            const poTemplate = languageFile["CONTRACT.WF.COMPENSATION.FIELD.PROJECT_ORDER"];

            const po = poTemplate
                .replace("{PROJECT_ORDER}", (workflowsQA['72'] || {}).notificationName);

            fields.ProjectOrder = { visible: true, label: po, required: false };
        }
    }
    if (contract?.ispackaged === true) {
        fields.AssessmentAmount.visible = false;
    }
    else {
        fields.AssessmentAmount = { visible: true, label: languageFile["GENERAL.FORMS.FIELD.CHANGE_IN_THE_PRICES"], required: true };
    }
    fields.AlternativeQuotation = { visible: true, label: languageFile["GENERAL.FORMS.FIELD.DELAY_TO_PLANNED_COMPLETION"], required: true };
    fields.Description = { visible: true, label: languageFile["GENERAL.FORMS.FIELD.DETAILS"], required: true };

    return fields;
}

///ALL REPLY FIELDS ARE DECIDED WITHIN THE getReplyFields FUNCTION
///THE getReplyFields FUNCTION IS CALLED WITHIN THE adjustContractTemplate and assign replyFields to workflowItem
export const getReplyFields = (resources, placeholdersQA, workflowsQA, languageFile, wfid) => {
    const replyFields = { ...defaultReplyFields };

    const replyOptions = [
        { field: "QA", display: "Accepted" },
        { field: "DNG", display: "Not Accepted" },
    ]

    replyFields.ReplyStatus = { visible: true, label: languageFile["GENERAL.FORMS.FIELD.STATUS"], required: true };
    replyFields.ReplyStatus.replyOptions = replyOptions;
    replyFields.ReplyComment = { visible: true, label: languageFile["GENERAL.FORMS.FIELD.COMMENTS"], required: true };
    return replyFields;
}

class ClaimsRouter extends React.Component {
    constructor(props) {
        super(props);
        this.notificationType = "CLAIM";
        this.documentType = 'DocumentClaim';

        this.notifyingParty = props.workflowItem.notifyingParty;
        this.replyingParty = props.workflowItem.replyingParty;

        this.notificationName = props.workflowItem.notificationName;
        this.abbreviation = props.workflowItem.abbreviation;
        this.replyPeriod = props.workflowItem.replyPeriod;

        // #region TASK ORDER ENABLED
        this.taskOrderOptionEnabled = false;
        try {
            if (props.placeholdersQA.TaskOrderOptionEnabled) {
                this.taskOrderOptionEnabled = props.placeholdersQA.TaskOrderOptionEnabled.values
                    .find(phItem => phItem.field === 'TaskOrderOptionEnabled').isActive;
            }
        } catch (error) {
            console.log('TaskOrderOptionEnabled placeholder not available!');
            this.taskOrderOptionEnabled = false;
        }
        //#endregion

        if (this.taskOrderOptionEnabled) {
            this.taskOrderNotificationName = (this.props.workflowsQA['38'] || {}).notificationName;
        }

        // #region PROJECT ORDER ENABLED
        this.projectOrderOptionEnabled = false;
        try {
            if (props.placeholdersQA.ProjectOrderOptionEnabled) {
                this.projectOrderOptionEnabled = props.placeholdersQA.ProjectOrderOptionEnabled.values
                    .find(phItem => phItem.field === 'ProjectOrderOptionEnabled').isActive;
            }
        } catch (error) {
            console.log('ProjectOrderOptionEnabled placeholder not available!');
            this.projectOrderOptionEnabled = false;
        }
        //#endregion

        if (this.projectOrderOptionEnabled) {
            this.projectOrderNotificationName = (this.props.workflowsQA['72'] || {}).notificationName;
        }
    }
    shouldComponentUpdate() {
        return false;
    }
    render() {
        const { workflowItem } = this.props;

        return (
            <Routes caseSensitive>
                <Route
                    path={workflowItem.config.paths.list}
                    exact
                    element={<ClaimsList
                        {...this.props}
                        notificationType={this.notificationType}
                        title={this.notificationName}
                        abbreviation={this.abbreviation}
                        taskOrderOptionEnabled={this.taskOrderOptionEnabled}
                        taskOrderNotificationName={this.taskOrderNotificationName}
                        projectOrderOptionEnabled={this.projectOrderOptionEnabled}
                        projectOrderNotificationName={this.projectOrderNotificationName}
                    />
                    }
                />
                <Route
                    path={workflowItem.config.paths.create}
                    exact
                    element={
                        workflowItem.userFilters.mainNotice.createAllowed ? (
                            <ClaimsCreate
                                {...this.props}
                                title={this.notificationName}
                                notificationType={this.notificationType}
                                taskOrderOptionEnabled={this.taskOrderOptionEnabled}
                                taskOrderNotificationName={this.taskOrderNotificationName}
                                projectOrderOptionEnabled={this.projectOrderOptionEnabled}
                                projectOrderNotificationName={this.projectOrderNotificationName}
                            />) : (
                            <Navigate replace to={workflowItem.paths.defaultPath} />
                        )
                    }
                />
                <Route
                    path={'/:notificationid/*'}
                    exact
                    element={<ClaimsDetail
                        {...this.props}
                        replyPeriod={this.replyPeriod}
                        title={this.notificationName}
                        abbreviation={this.abbreviation}

                        notificationType={this.notificationType}
                        documentType={this.documentType}
                        notifyUserFilter={workflowItem.notifyUserFilter}
                        taskOrderOptionEnabled={this.taskOrderOptionEnabled}
                        taskOrderNotificationName={this.taskOrderNotificationName}
                        projectOrderOptionEnabled={this.projectOrderOptionEnabled}
                        projectOrderNotificationName={this.projectOrderNotificationName}
                    />}
                />
            </Routes>
        );
    }
};




export default (ClaimsRouter);